module.exports = __webpack_public_path__ + "media/images/pic/teachers/anna-sielawko-b974162d125334e673ecfbea70174586.webp";